// extracted by mini-css-extract-plugin
export default {"tagList":"TagList_tagList__Z5O-4"};